import exp from "../img/dusecaSoftware.jpg";

export const experienceData = [
  {
    img: exp,
    companyName: "GEDU TECHNOLOGIES",
    duration:"September 2022 - Present",
    role: "Junior Web Developer",
    workDone: `I worked as frontend web developer to design web based admin dashboards for mulitple apps using React.js, Next.js, Bootstrap, and some other libraries..`,
  },
];
